import { Outlet, useLocation } from 'react-router-dom';
import PageTransition from '../../components/PageTransition';
import { Navigation } from '../../components/shared/Navigation';
import { TopBar } from '../../components/shared/TopBar';

export function Layout() {
  const location = useLocation();


  return (
    <div className="flex flex-col justify-start items-center w-[100%] h-[100%]">
      <div className="relative w-full h-full overflow-hidden">
          <PageTransition key={location.pathname}>
            <TopBar/>
            <Outlet />
            <Navigation />
          </PageTransition>
      </div>
    </div>
  );
}
